export const useStyUtil_03 = ({ columnWidthRatios, totalRatio }: any) => {
  const getSty01 = (columnIndex: number = 0) => {
    const widthRatio = columnWidthRatios[columnIndex];

    return {
      width: `calc(100%*(${widthRatio}/${totalRatio}))`,
    };
  };
  return { getSty01 };
};
